import { api } from './index';
import { QSAnalysis, QSAnalysisDetail, QSAnforderung, QSReviewRequest } from '../types';

export const QSAnalysisService = {
  /**
   * Alle Analysen für QS/SuperQS abrufen
   * @param zeitraum - Zeitfilter: 'alle', 'heute', 'woche' (default), 'monat'
   */
  getAllAnalyses: async (zeitraum: string = 'woche'): Promise<QSAnalysis[]> => {
    const response = await api.get('/qs/analyses', {
      params: { zeitraum }
    });
    return response.data.data;
  },

  /**
   * Detaillierte Analyse für QS-Prüfung abrufen
   */
  getAnalysisDetail: async (analysisId: string): Promise<QSAnalysisDetail> => {
    const response = await api.get(`/qs/analyses/${analysisId}`);
    return response.data.data;
  },

  /**
   * QS-Prüfung starten (Status auf 'in_review' setzen)
   */
  startQSReview: async (analysisId: string): Promise<void> => {
    await api.post(`/qs/analyses/${analysisId}/start-review`);
  },

  /**
   * QS-Änderungen speichern (neues Format mit allen Anforderungen + Notizen)
   */
  saveQSChanges: async (
    analysisId: string,
    anforderungen: QSAnforderung[],
    notes?: string,
    anforderungNotes?: { [key: string]: string },
    reviewedAnforderungen?: number[]
  ): Promise<void> => {
    await api.post(`/qs/analyses/${analysisId}/changes`, {
      anforderungen,
      notes,
      anforderungNotes,
      reviewedAnforderungen,
    });
  },

  /**
   * QS-Prüfung abschließen (genehmigen oder ablehnen)
   */
  submitQSReview: async (analysisId: string, review: QSReviewRequest): Promise<void> => {
    await api.post(`/qs/analyses/${analysisId}/submit-review`, review);
  },

  /**
   * SuperQS-Prüfung abschließen
   */
  submitSuperQSReview: async (analysisId: string, review: QSReviewRequest): Promise<void> => {
    await api.post(`/qs/analyses/${analysisId}/super-qs-review`, review);
  },

  /**
   * Änderungen für eine Anforderung zurücksetzen
   */
  resetAnforderungChanges: async (analysisId: string, anforderungNummer: number): Promise<void> => {
    await api.post(`/qs/analyses/${analysisId}/reset-anforderung/${anforderungNummer}`);
  },

  /**
   * Alle Änderungen zurücksetzen
   */
  resetAllChanges: async (analysisId: string): Promise<void> => {
    await api.post(`/qs/analyses/${analysisId}/reset-all`);
  },
}; 